import { NgModule, Optional, SkipSelf } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { AuthenticationEffects } from './authentication.effects';
import { IAuthenticationFeature } from './authentication.feature.state';
import { authenticationReducer } from './authentication.reducer';
import { nameof } from '@symphony-solo/shared/utils/src';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<IAuthenticationFeature>('authenticationFeature'), authenticationReducer),
    EffectsModule.forFeature([AuthenticationEffects]),
  ],
})
export class AuthenticationStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: AuthenticationStateModule
  ) {
    if (parentModule) {
      throw new Error('AuthenticationStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
